'use client'

import type { ComponentProps } from 'react'
import SeatMapMinimap from './SeatMapMinimap'
import { useMapTransform, type MapTransformStore } from '@/lib/seat-map/transform-store'

type MinimapProps = ComponentProps<typeof SeatMapMinimap>

/**
 * SeatMapMinimap fed from a transform store, so following the map's pan and
 * zoom re-renders the minimap alone instead of the page that holds both.
 */
export default function LiveSeatMapMinimap({ transformStore, ...props }: Omit<MinimapProps, 'transform'> & { transformStore: MapTransformStore }) {
  const transform = useMapTransform(transformStore)
  return <SeatMapMinimap {...props} transform={transform} />
}
